<modal
  [id]="id()"
  [header]="'Remove selected entries'"
  [headerIcon]="headerIcon"
  [closeButtonEnabled]="true"
  [showFooterDivider]="false"
  [widthClass]="'tw-w-[343px] lg:tw-w-[560px]'"
  [heightClass]="'tw-h-auto'"
  [enableBackdropClose]="true"
  (onCloseModal)="onModalClose()"
>
  <div slot="body" class="tw-flex tw-flex-col tw-gap-8 tw-font-inter">
    @if (isLoading() || !preview()) {
      <div class="tw-flex tw-min-h-[160px] tw-w-full tw-items-center tw-justify-center">
        <progress-circle colorClasses="tw-border-blue-500 tw-border-r-gray-300"></progress-circle>
      </div>
    } @else {
      <div class="tw-flex tw-flex-col tw-gap-6 tw-w-full">
        <div class="tw-flex tw-flex-col tw-gap-4 tw-w-full tw-text-base tw-font-normal tw-leading-normal tw-text-gray-700">
          <p class="tw-m-0 tw-w-full tw-font-inter tw-text-base">
            You've selected <strong class="tw-font-semibold">{{ selectedCountLabel() }}</strong> to remove from the
            <strong class="tw-font-semibold">{{ personaName() }}</strong> invitation collection.
          </p>

          @if (preview()!.will_be_removed > 0) {
            <ul class="tw-m-0 tw-w-full tw-list-disc tw-pl-6">
              <li class="tw-leading-normal tw-font-inter tw-text-base">{{ willBeRemovedLabel() }}</li>
            </ul>
          }

          @if (preview()!.wont_be_removed > 0) {
            <ul class="tw-m-0 tw-w-full tw-list-disc tw-pl-6">
              <li class="tw-leading-normal tw-font-inter">{{ wontBeRemovedLabel() }}</li>
            </ul>
          }
        </div>

        <div class="tw-flex tw-items-start tw-gap-2 tw-w-full">
          <div class="tw-flex tw-h-6 tw-items-center tw-shrink-0">
            <svg class="tw-w-4 tw-h-4 tw-block" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
              <g clip-path="url(#bulk_delete_info_clip)">
                <path
                  d="M7.99902 0.5C9.98762 0.502184 11.8946 1.29307 13.3008 2.69922C14.6191 4.01752 15.3964 5.77569 15.4902 7.62891L15.5 8.00098C15.4998 9.48399 15.0603 10.9339 14.2363 12.167C13.4122 13.4003 12.2405 14.361 10.8701 14.9287C9.49973 15.4963 7.99191 15.6448 6.53711 15.3555C5.08225 15.0661 3.74518 14.3526 2.69629 13.3037C1.6474 12.2548 0.93392 10.9177 0.644531 9.46289C0.355194 8.00809 0.503657 6.50027 1.07129 5.12988C1.63895 3.7595 2.59968 2.58776 3.83301 1.76367C5.0661 0.939743 6.516 0.500193 7.99902 0.5ZM7.59961 2.7002C7.14888 2.7003 6.71618 2.87952 6.39746 3.19824C6.07889 3.51702 5.90039 3.94971 5.90039 4.40039C5.90047 4.73648 5.9998 5.06527 6.18652 5.34473C6.34307 5.57895 6.55543 5.76898 6.80273 5.90039H6.40039C6.05565 5.90039 5.72426 6.03654 5.48047 6.28027C5.23667 6.52407 5.09961 6.85541 5.09961 7.2002C5.09966 7.54481 5.23684 7.87541 5.48047 8.11914C5.72427 8.36294 6.05561 8.5 6.40039 8.5H6.7002V9.90039H6.40039C6.05565 9.90039 5.72426 10.0365 5.48047 10.2803C5.23667 10.5241 5.09961 10.8554 5.09961 11.2002C5.09966 11.5448 5.23684 11.8754 5.48047 12.1191C5.72427 12.3629 6.05561 12.5 6.40039 12.5H9.59961C9.94439 12.5 10.2757 12.3629 10.5195 12.1191C10.7632 11.8754 10.9003 11.5448 10.9004 11.2002C10.9004 10.8554 10.7633 10.5241 10.5195 10.2803C10.2757 10.0365 9.94435 9.90039 9.59961 9.90039H9.2998V7.2002C9.2998 6.85541 9.16274 6.52407 8.91895 6.28027C8.75136 6.11283 8.54238 5.9972 8.31641 5.94043C8.49565 5.85707 8.66047 5.74374 8.80176 5.60254C9.03951 5.36479 9.20198 5.06121 9.26758 4.73145C9.33311 4.40175 9.29954 4.05958 9.1709 3.74902C9.04225 3.43858 8.8243 3.17307 8.54492 2.98633C8.26536 2.79953 7.93584 2.7002 7.59961 2.7002Z"
                  fill="#1C64F2"
                  stroke="#1C64F2"
                />
              </g>
              <defs>
                <clipPath id="bulk_delete_info_clip">
                  <rect width="16" height="16" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </div>
          <p class="tw-m-0 tw-flex-1 tw-min-w-0 tw-text-base tw-font-normal tw-leading-normal tw-text-gray-700 tw-font-inter">
            Entries who have already been invited can't be removed from the invitation tracking list.
          </p>
        </div>
      </div>
    }

    <div class="tw-flex tw-w-full tw-flex-col-reverse tw-gap-3 lg:tw-flex-row lg:tw-items-center lg:tw-justify-end lg:tw-gap-4">
      <button
        type="button"
        class="tw-flex tw-h-[41px] lg:tw-h-[52px] tw-w-full lg:tw-w-auto tw-items-center tw-justify-center tw-gap-2 tw-rounded-lg tw-border tw-border-solid tw-border-gray-200 tw-bg-white tw-px-5 lg:tw-px-6 tw-py-2.5 lg:tw-py-3.5 tw-text-sm lg:tw-text-base tw-font-medium tw-leading-normal tw-text-gray-800 tw-font-inter tw-cursor-pointer"
        (click)="onCancel()"
      >
        Cancel
      </button>
      @if (!isLoading() && preview()) {
        <button
          type="button"
          class="tw-flex tw-h-[41px] lg:tw-h-[52px] tw-w-full lg:tw-w-auto tw-items-center tw-justify-center tw-gap-2 tw-rounded-lg tw-border-0 tw-bg-red-600 tw-px-5 lg:tw-px-6 tw-py-2.5 lg:tw-py-3.5 tw-text-sm lg:tw-text-base tw-font-medium tw-leading-normal tw-text-white tw-font-inter tw-cursor-pointer"
          (click)="onConfirm()"
        >
          {{ confirmLabel() }}
        </button>
      }
    </div>
  </div>
</modal>
